import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject } from 'rxjs';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { AddBussinessRulesComponent } from '../add-bussiness-rules/add-bussiness-rules.component';

@Component({
  selector: 'app-bussiness-rules-data-table',
  templateUrl: './bussiness-rules-data-table.component.html',
  styleUrls: ['./bussiness-rules-data-table.component.scss']
})
export class BussinessRulesDataTableComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  @Input() tableDataNew: any;
  @Output() refreshTableData = new EventEmitter();
  isSuperUser: boolean;

  constructor(private spinnerService: Ng4LoadingSpinnerService,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

  ngOnInit(): void {
    this.isSuperUser = Boolean(sessionStorage.getItem("isSuperUser")==="true");
    this.dtOptions = {
      paging: true,
      pagingType: 'full_numbers',
      scroller: true,
      scrollCollapse: true,
      scrollX: true,
      responsive: true,
      select: true,
      dom: '<\'row\'<\'col-sm-12 col-md-3\'l><\'col-sm-12 col-md-3\'B><\'col-sm-12 col-md-6\'f>>' +
        '<\'row\'<\'col-sm-12\'tr>>' +
        '<\'row\'<\'col-sm-12 col-md-3 entries\'i><\'col-sm-12 col-md-9 entries\'p>>',
      buttons: [
        {
          extend: 'csv',
          title: 'Bussiness',
          exportOptions: {
            columns: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]
          }
        },
        {
          extend: 'excel',
          title: 'Bussiness',
          exportOptions: {
            columns: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]
          }
        }
      ], columnDefs: [{
        targets: [18], // column or columns numbers
        orderable: false  // set orderable for selected columns
      }]
    };
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  deleteRow(item: any) {
    if (confirm('Do You Want To Delete ?')) {
      this.spinnerService.show();
      const formData = new FormData();
      this.backendApiService.callToApi(this.endpointsService.URL_DELETE_BUSINESS_RULES +
        '&sno=' + item['sno'])
        .subscribe(response => {
          if (response === true) {
            alert('Deleted Successfully');
            this.refreshTableData.emit();
          } else {
            alert('Not Deleted.Please Check with Administrator');
            this.refreshTableData.emit();
          }
          this.spinnerService.hide();
        });
    }
  }

  editBussines(row) {
    const dialogRef = this.dialog.open(AddBussinessRulesComponent, {
      height: '600px',
      panelClass: 'custom-modalbox',
      data: { type: 'Edit', dataValues: row },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed : ' + result);
      this.refreshTableData.emit();
    });
  }

  viewBussiness(row) {
    const dialogRef = this.dialog.open(AddBussinessRulesComponent, {
      height: '600px',
      panelClass: 'custom-modalbox',
      data: { type: 'View', dataValues: row },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed : ' + result);
      this.refreshTableData.emit();
    });
  }

}
